// extracted by mini-css-extract-plugin
export default {"container":"NotificationPendingUpdate_container__oZBGY","regular-text":"NotificationPendingUpdate_regular-text__Ub9C2","bold-text":"NotificationPendingUpdate_bold-text__aYLYx"};